export default "__VITE_ASSET__CPjavcFk__"